// Sin dependencias: lo importan apiClient, api, AuthContext y SessionManager sin ciclos.

/** Motivos conocidos para /login?reason=...; cualquier otro valor se ignora (nunca se pinta crudo). */
export const LOGIN_REASONS = ['password_changed', 'session_expired'] as const;
export type LoginReason = (typeof LOGIN_REASONS)[number];

/**
 * Lee el motivo de /login. Solo acepta valores conocidos. Por compatibilidad, el formato
 * viejo ?expired=true (enlaces o pestanas antiguas) se trata como session_expired.
 */
export function parseLoginReason(search: string | null | undefined): LoginReason | null {
  if (!search) return null;
  const params = new URLSearchParams(search);
  const value = params.get('reason') ?? '';
  if ((LOGIN_REASONS as readonly string[]).includes(value)) return value as LoginReason;
  if (params.get('expired') === 'true') return 'session_expired';
  return null;
}

export function loginUrlFor(reason?: LoginReason): string {
  return reason ? `/login?reason=${reason}` : '/login';
}

let pendingRedirect: string | null = null;

/**
 * Navegacion completa a `url` una sola vez: si ya hay una redireccion en curso, o ya estamos
 * en esa misma URL, no vuelve a asignar location. Devuelve true si navego.
 */
export function redirectOnce(url: string): boolean {
  if (pendingRedirect !== null) return false;
  const { pathname, search } = window.location;
  if (`${pathname}${search}` === url) return false;
  pendingRedirect = url;
  window.location.assign(url);
  return true;
}

/** Solo para tests. */
export function __resetRedirectForTests(): void {
  pendingRedirect = null;
}
